import KindergartenMenu from "../Component/kindergartenMenu";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
const KidsFeeDetails = () => {
  return (
    <>
      <KindergartenMenu />
      <Breadcrumb
        title="Fees Details"
        mid="Kindergarten &nbsp; &nbsp;|"
        tabName="Fees Details"
      />
      <div className="innerPage">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div class="table-responsive table-wid">
                {/* 
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th rowSpan={2}>Class</th>
                                            <th colSpan={3}>For year 2025-26 FEES (in rupees)</th>
                                        </tr>
                                        <tr>
                                            <th>Tuition Fees</th>
                                            <th>Term Fees</th>
                                            <th>Total Fees</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>NURSERY</td>
                                            <td>54176</td>
                                            <td>9030</td>
                                            <td>63206</td>
                                        </tr>
                                        <tr>
                                            <td>LKG</td>
                                            <td>54176</td>
                                            <td>9030</td>
                                            <td>63206</td>
                                        </tr>
                                        <tr>
                                            <td>HKG</td>
                                            <td>51700</td>
                                            <td>8616</td>
                                            <td>60316</td>
                                        </tr>
                                    </tbody>
                                </table> 
                                */}
                {/* <h3><b>Approved fees by FRC for year 2024-25, 2025-26 & 2026-27</b></h3>
                                <div class="table-responsive ">
                                    <table class="table table-bordered table-striped text-center align-middle ">
                                        <thead class="table-dark">
                                            <tr>
                                                <th rowspan="2">Class</th>
                                                <th colspan="3">For year 2024-25
                                                    FEES (in rupees)</th>
                                                <th colspan="3">For year 2025-26
                                                    FEES (in rupees)</th>
                                                <th colspan="3">For year 2026-27
                                                    FEES (in rupees)</th>
                                            </tr>
                                            <tr>
                                                <th>Tuition Fees</th>
                                                <th>Term Fees</th>
                                                <th>Total Fees</th>
                                                <th>Tuition Fees</th>
                                                <th>Term Fees</th>
                                                <th>Total Fees</th>
                                                <th>Tuition Fees</th>
                                                <th>Term Fees</th>
                                                <th>Total Fees</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Nursery</td>
                                                <td>49,250</td>
                                                <td>8,208</td>
                                                <td><strong>57,458</strong></td>
                                                <td>50,000</td>
                                                <td>8,334</td>
                                                <td><strong>58,334</strong></td>
                                                <td>51,000</td>
                                                <td>8,500</td>
                                                <td><strong>59,500</strong></td>
                                            </tr>
                                            <tr>
                                                <td>LKG</td>
                                                <td>49,250</td>
                                                <td>8,208</td>
                                                <td><strong>57,458</strong></td>
                                                <td>50,000</td>
                                                <td>8,334</td>
                                                <td><strong>58,334</strong></td>
                                                <td>51,000</td>
                                                <td>8,500</td>
                                                <td><strong>59,500</strong></td>
                                            </tr>
                                            <tr>
                                                <td>HKG</td>
                                                <td>47,000</td>
                                                <td>7,834</td>
                                                <td><strong>54,834</strong></td>
                                                <td>48,000</td>
                                                <td>8,000</td>
                                                <td><strong>56,000</strong></td>
                                                <td>49,000</td>
                                                <td>8,167</td>
                                                <td><strong>57,167</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> */}
                <h3>
                  <b>
                   Approved fees by FRC for year 2024-25, 2025-26 & 2026-27
                  </b>
                </h3>
                <div class="table-responsive ">
                  <table class="table table-bordered table-striped text-center align-middle ">
                    <thead class="table-dark">
                      <tr>
                        <th rowspan="2">Class</th>
                        <th>For year 2024-25 FEES (in rupees)</th>
                        <th>For year 2025-26 FEES (in rupees)</th>
                        <th>For year 2026-27 FEES (in rupees)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>NURSERY</td>
                        <td>
                          <strong>49250</strong>
                        </td>
                        <td>
                          <strong>50000</strong>
                        </td>
                        <td>
                          <strong>51000</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>LKG</td>
                        <td>
                          <strong>49250</strong>
                        </td>
                        <td>
                          <strong>50000</strong>
                        </td>
                        <td>
                          <strong>51000</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>HKG</td>
                        <td>
                          <strong>47000</strong>
                        </td>
                        <td>
                          <strong>48000</strong>
                        </td>
                        <td>
                          <strong>49000</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default KidsFeeDetails;
